/* ==========================================
   SOLES FOR LESS — THEME JAVASCRIPT
   Header, Navigation, Search & Recommendations
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  /* ==========================================
     MOBILE NAVIGATION
  ========================================== */

  const menuButton = document.querySelector("[data-menu-toggle]");
  const menu = document.getElementById("mobile-menu");

  const searchButton = document.querySelector("[data-search-toggle]");
  const search = document.getElementById("header-search");

  // Toggle mobile navigation
  if (menuButton && menu) {

    menuButton.addEventListener("click", () => {

      const open = menu.hidden;

      menu.hidden = !open;

      menuButton.setAttribute(
        "aria-expanded",
        String(open)
      );

      // Close search when opening navigation
      if (open && search) {

        search.hidden = true;

        searchButton?.setAttribute(
          "aria-expanded",
          "false"
        );

      }

    });

  }


  /* ==========================================
     HEADER SEARCH
  ========================================== */

  if (searchButton && search) {

    searchButton.addEventListener("click", () => {

      const open = search.hidden;

      search.hidden = !open;

      searchButton.setAttribute(
        "aria-expanded",
        String(open)
      );

      if (open) {

        // Focus search input
        search.querySelector(
          'input[type="search"]'
        )?.focus();

        // Close mobile menu
        if (menu) {

          menu.hidden = true;

          menuButton?.setAttribute(
            "aria-expanded",
            "false"
          );

        }

      }

    });

  }

});


/* ==========================================
   RELATED PRODUCT RECOMMENDATIONS
   Lazy Loading
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const section = document.querySelector(
    "[data-recommendations]"
  );

  if (!section || !section.dataset.url) {
    return;
  }

  /* ==========================================
     FETCH RELATED PRODUCTS
  ========================================== */

  const loadRecommendations = async () => {

    try {

      const response = await fetch(
        section.dataset.url
      );

      if (!response.ok) {
        return;
      }

      const html = await response.text();

      const documentHTML = new DOMParser().parseFromString(
        html,
        "text/html"
      );

      const updatedSection = documentHTML.querySelector(
        "[data-recommendations]"
      );

      if (
        updatedSection &&
        updatedSection.querySelector(".product-grid")
      ) {

        section.innerHTML = updatedSection.innerHTML;

      }

    } catch (error) {

      console.warn(
        "Related products unavailable:",
        error
      );

    }

  };


  /* ==========================================
     LAZY LOAD USING INTERSECTION OBSERVER
  ========================================== */

  if ("IntersectionObserver" in window) {

    const observer = new IntersectionObserver(
      (entries) => {

        if (entries[0].isIntersecting) {

          observer.disconnect();

          loadRecommendations();

        }

      },
      {
        rootMargin: "250px"
      }
    );

    observer.observe(section);

  } else {

    // Fallback for older browsers
    loadRecommendations();

  }

});